module.exports = __webpack_public_path__ + "img/compact.e68858d0.png";